/**
 * useSendNowOutreachMessage — the row menu's single-message recovery
 * (review CRITICAL-2 on #525): unlike useResendOutreachMessages (the bulk
 * resend_messages operation, failed rows only), this hits the reason-aware
 * single-row send-now route directly, so a held row's precise fix sentence
 * (sendNowHeldFix) reaches the caller instead of dead-ending with
 * needs_single_row_route.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OutreachQueuedMessage } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { sendNowOutreachMessage } from '../api/outreachApi';

export interface SendNowVars {
  entryId: string;
  messageId: number;
}

export function useSendNowOutreachMessage(campaignId: string) {
  const queryClient = useQueryClient();
  return useMutation<OutreachQueuedMessage, Error, SendNowVars>({
    mutationFn: ({ entryId, messageId }) => sendNowOutreachMessage(entryId, messageId, crypto.randomUUID()),
    onSuccess: (_data, { entryId }) => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.outreachThread(entryId) });
      queryClient.invalidateQueries({ queryKey: campaignKeys.outreachRowsAll(campaignId) });
      queryClient.invalidateQueries({ queryKey: campaignKeys.outreachCounts(campaignId) });
    },
  });
}
